import { render } from "./WCCollapseCardGroup.vue?vue&type=template&id=55b570af&scoped=true"
import script from "./WCCollapseCardGroup.vue?vue&type=script&lang=js"
export * from "./WCCollapseCardGroup.vue?vue&type=script&lang=js"

import "./WCCollapseCardGroup.vue?vue&type=style&index=0&id=55b570af&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b570af"]])

export default __exports__